
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cpd/cpd-terms",
      function () {
        return require("private-next-pages/cpd/cpd-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cpd/cpd-terms"])
      });
    }
  